module.exports = __webpack_public_path__ + "img/flex5_3_Extended-back.606ac7cd.jpg";